import ExternalLink from '@src/app-components/external-link/ExternalLink';

const textContent = {
  areaInstructions: (
    <>
      For proposed impact amounts, enter length and width for streams and either length and width or area for wetlands
      and other waterbodies. If you enter a length and width, area will be calculated for you.
    </>
  ),

  informativeVideo: (
    <>
      View this{' '}
      <ExternalLink href='https://youtu.be/nQ6RxHmczXg' target='_blank'>
        video demonstration
      </ExternalLink>{' '}
      of how to enter project impacts and mitigation.
    </>
  ),

  buttonInstructions: (
    <>
      <p>
        Use the "Add New Row" button to individually add impacts and mitigation to the inventory table. If you have many
        impacts and/or compensatory mitigation, you can use the drag and drop feature to add multiple impacts and
        mitigation at one time using the CSV bulk upload templates.
      </p>
      <p>
        When uploading your data, please ensure that the Water Name/Label field in your Impacts Upload file exactly
        matches the corresponding Water Name/Label value in the Aquatic Resource table.{' '}
        <span className='text-bold text-italic'>
          Any difference in spacing or capitalization will prevent the system from linking your data.
        </span>
      </p>
    </>
  ),

  compensatoryMitigationExplanation: (
    <>
      Explain how compensatory mitigation requirements in paragraph (c) of general condition 23 will be satisfied or
      explain why the adverse environmental effects are no more than minimal and why compensatory mitigation should not
      be required for the proposed activity
    </>
  ),

  instructions: (
    <>
      Provide an inventory of all proposed impacts to aquatic resources on the project site and any proposed
      compensatory mitigation. Impacts and mitigation can be provided in this section by adding them individually or
      bulk loading them using the provided bulk upload CSV.
    </>
  ),

  ipImpactAdditionalDetailsLabel: (
    <>
      Provide any additional information you may have about the proposed quantity of wetlands, streams, or other types
      of waters directly affected by the proposed activity. This level of detail is helpful to better understand the
      type of impacts that are proposed for your project.
    </>
  ),

  gpImpactAdditionalDetailsLabel: (
    <>
      Provide any additional information you may have about the proposed quantity of wetlands, streams, or other types
      of waters directly affected by the proposed Nationwide Permit activity. This level of detail is helpful to better
      understand the type of impacts that are proposed for your project.
    </>
  ),

  ipFormHeaderSubtext: (
    <>
      {' '}
      For discharges of dredged or fill material into waters of the United States, provide the amount of wetlands,
      streams, or other types of waters filled, flooded, excavated, or drained by the proposed activity. For structures
      or work in navigable waters of the United States subject to Section 10 of the Rivers and Harbors Act of 1899,
      provide the amount of navigable waters filled, dredged, or occupied by one or more structures (e.g., aids to
      navigation, mooring buoys) by the proposed activity.
    </>
  ),

  gpFormHeaderSubtext: (
    <>
      {' '}
      For discharges of dredged or fill material into waters of the United States, provide the amount of wetlands,
      streams, or other types of waters filled, flooded, excavated, or drained by the proposed NWP activity. For
      structures or work in navigable waters of the United States subject to Section 10 of the Rivers and Harbors Act of
      1899, provide the amount of navigable waters filled, dredged, or occupied by one or more structures (e.g., aids to
      navigation, mooring buoys) by the proposed NWP activity.
    </>
  ),

  locationInstructions: (
    <>
      In general, mitigation should be located within the same watershed as the impact site and should be located where
      it is most likely to successfully replace lost functions and services. USACE considers the type and location
      options for mitigation in the following order although flexibility in approach can be exercised on a
      project-specific basis: mitigation bank credits, in-lieu fee program credits, permittee responsible mitigation
      under a watershed approach, permittee responsible mitigation through on-site and in-kind mitigation, and permittee
      responsible mitigation through off-site and/or out-of-kind mitigation.
    </>
  ),

  willResultInWetlandLossLabel: (
    <>Will the proposed activity result in a loss to wetlands or waters that exceeds National or District thresholds?</>
  ),
};

export default textContent;
